import * as React from 'react';
import {loadModules} from 'esri-loader';

export default class GroupLayer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            groupLayer: null
        };
    }

    render() {
        return null;
    }

    componentDidMount() {
        loadModules([
            'esri/layers/GroupLayer',
            'esri/layers/FeatureLayer',
            "esri/PopupTemplate"
        ]).then(([GroupLayer, FeatureLayer, PopupTemplate]) => {
            const urlMapServer = this.props.urlMapServer ? this.props.urlMapServer : '';

            const layers = this.props.layers ? this.props.layers : [];

            const groupLayers = [];

            const prepareFeature = (featureLayer) => {
                featureLayer.on("layerview-create", function (event) {
                    let eventLayer = event.target;
                    if(!event.target){
                        eventLayer = event.layerView.layer;
                    }
                    if(eventLayer && eventLayer.fields){
                        let fields = eventLayer.fields.map((el) => {
                            return {fieldName: el.name, label: el.alias}
                        });

                        eventLayer.popupTemplate = new PopupTemplate({content: [{type: 'fields', fieldInfos: fields}]});
                        eventLayer.renderer.uniqueValueInfos.forEach((layer) => {
                            if (layer['symbol'] && layer['symbol']['outline'] && layer['symbol']['outline']['width'] > 6) {
                                layer['symbol']['outline']['width'] = 1;
                            }
                        });
                    }
                });
            };

            for (let layer of layers) {
                if(typeof layer === 'object'){
                    groupLayers.push(layer);
                } else{
                    let feature = new FeatureLayer({
                        url: urlMapServer + layer,
                        outFields: ['*'],
                        visible: !!this.props.visible,
                        featureReduction: {type: "selection"}
                    });

                    prepareFeature(feature);
                    groupLayers.push(feature);
                }
            }

            let groupLayerProps = {
                title: this.props.title ? this.props.title : 'Nimeta',
                id: 'ignore_id',
                visible: false,
                layers: groupLayers,
                opacity: this.props.opacity
            };

            if(this.props.id){
                groupLayerProps['id'] = this.props.id
            }

            const groupLayer = new GroupLayer(groupLayerProps);

            this.setState({groupLayer});

            this.props.map.add(groupLayer, 0);

        }).catch((err) => console.error(err));
    }

    componentWillReceiveProps(nextProps, nextContext) {
        // console.log(nextProps);
    }

    componentWillUnmount() {
        this.props.map.remove(this.state.layer);
    }
}

GroupLayer.defaultProps = {
    opacity: 0.75
};
